export const euro = (cents) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format((cents || 0) / 100);

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return iso; }
};

export const WEEKDAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];

export const REQUEST_STATUS_LABELS = {
  inviata: "Inviata",
  in_valutazione: "In valutazione",
  in_gestione: "Presa in carico",
  professionista_trovato: "Professionista trovato",
  in_attesa_di_pagamento: "In attesa di pagamento",
  prenotata: "Prenotata",
  completata: "Completata",
  annullata: "Annullata",
};

export const BOOKING_STATUS_LABELS = {
  in_attesa_di_conferma: "In attesa di conferma",
  confermata: "Confermata",
  completata: "Completata",
  annullata: "Annullata",
};

export const PAYMENT_STATUS_LABELS = {
  non_pagato: "Non pagato",
  in_attesa: "In attesa",
  pagato: "Pagato",
  demo_pagato: "Pagato (demo)",
  fallito: "Fallito",
  rimborsato: "Rimborsato",
  gestito_offline: "Gestito dal professionista",
};

export const VERIFICATION_LABELS = {
  da_verificare: "Da verificare",
  verificato: "Verificato",
  rifiutato: "Rifiutato",
  scaduto: "Scaduto",
};

// tone: green | yellow | red | gray
export const statusTone = (status) => {
  if (["prenotata", "completata", "confermata", "verificato", "pagato", "demo_pagato", "gestito_offline", "in_gestione"].includes(status)) return "green";
  if (["annullata", "rifiutato", "fallito", "scaduto"].includes(status)) return "red";
  if (["in_attesa_di_pagamento", "in_attesa_di_conferma", "da_verificare", "in_attesa", "inviata", "in_valutazione"].includes(status)) return "yellow";
  return "gray";
};
